export enum ChangedPageEnum {
    DashboardLayoutConfiguration = 'DashboardLayoutConfiguration'
}